// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2tvwd","footer":"ReportModalFilter_footer__3xLYn"};